import React from 'react';
import AdvancedFilters, { FilterConfig } from './AdvancedFilters';

/**
 * Filtro de condomínio no cabeçalho do app — mesmo componente/mecanismo de
 * `DemandFilters`/`ReportsFilters`/`SuggestionsFilters` (ligado ao `DemandsContext`, com a mesma
 * regra de escolha única e herança da seleção feita em outra página), mas só a opção de
 * condomínio: usado em Checklists e Patrimônio (pedido do usuário, 03/09) — esses cadastros não
 * têm data/categoria/prioridade/QR code como as demandas, mesmo raciocínio de
 * `SuggestionsFilters`.
 */
export const ClientOnlyFilters: React.FC = () => {
  const filterConfig: FilterConfig = {
    showClientFilter: true,
    showDateRangeFilter: false,
    showCategoryFilter: false,
    showPriorityFilter: false,
    showQrCodeFilter: false,
    showSimilarOnlyFilter: false,
    pageType: 'reports',
    variant: 'compact',
  };

  return <AdvancedFilters config={filterConfig} />;
};

export default ClientOnlyFilters;
